import { Link, useLocation } from 'react-router-dom'
import { MessageSquareHeart, PackagePlus } from 'lucide-react'

export const FEEDBACK_PATH = '/feedback'
export const REQUEST_ITEM_PATH = '/request-item'

const actionClass =
  'inline-flex h-10 min-w-0 flex-1 items-center justify-center gap-2 rounded-full border px-3 text-sm font-medium shadow-sm transition-colors sm:flex-none sm:px-4'

/** Secondary home actions (feedback, item request): links to their own routes, where the form replaces the item lists. */
export default function HomeQuickActions() {
  const { pathname } = useLocation()

  const actions = [
    {
      to: FEEDBACK_PATH,
      label: 'Share feedback',
      icon: <MessageSquareHeart className="h-4 w-4 shrink-0" aria-hidden />,
      iconColor: 'text-primary-600',
    },
    {
      to: REQUEST_ITEM_PATH,
      label: 'Request an item',
      icon: <PackagePlus className="h-4 w-4 shrink-0" aria-hidden />,
      iconColor: 'text-emerald-600',
    },
  ]

  return (
    <nav className="mt-3 flex gap-2 sm:mt-4 sm:gap-3" aria-label="Store actions">
      {actions.map((a) => {
        const active = pathname === a.to
        return (
          <Link
            key={a.to}
            to={a.to}
            aria-current={active ? 'page' : undefined}
            className={`${actionClass} ${
              active
                ? 'border-primary-500 bg-primary-500 text-white'
                : 'border-stone-300 bg-white text-stone-800 hover:border-primary-300 hover:bg-primary-50 active:bg-primary-100'
            }`}
          >
            <span className={active ? 'text-white' : a.iconColor}>{a.icon}</span>
            <span className="truncate">{a.label}</span>
          </Link>
        )
      })}
    </nav>
  )
}
